import { render } from "./BarraAvisoUsuarioSuporte.vue?vue&type=template&id=449543a4&scoped=true"
import script from "./BarraAvisoUsuarioSuporte.vue?vue&type=script&lang=js"
export * from "./BarraAvisoUsuarioSuporte.vue?vue&type=script&lang=js"

import "./BarraAvisoUsuarioSuporte.vue?vue&type=style&index=0&id=449543a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449543a4"],['__file',"src/common/BarraAvisoUsuarioSuporte/BarraAvisoUsuarioSuporte.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "449543a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('449543a4', __exports__)) {
    api.reload('449543a4', __exports__)
  }
  
  module.hot.accept("./BarraAvisoUsuarioSuporte.vue?vue&type=template&id=449543a4&scoped=true", () => {
    api.rerender('449543a4', render)
  })

}


export default __exports__